const SvgIcon = ({ size = '24', color = '#fff' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    stroke={color}
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    className="lucide lucide-lock-keyhole-open-icon lucide-lock-keyhole-open"
    viewBox="0 0 24 24"
  >
    <circle cx="12" cy="16" r="1"></circle>
    <rect width="18" height="12" x="3" y="10" rx="2"></rect>
    <path d="M7 10V7a5 5 0 0 1 9.33-2.5"></path>
  </svg>
);
export default SvgIcon;

// const SvgIcon = ({ size='24', color='#000' }) => (
//   <svg
//     xmlns="http://www.w3.org/2000/svg"
//     id="svg1362"
//     width={size}
//     height={size}
//     fill="none"
//     version="1.1"
//     viewBox="0 0 24 24"
//   >
//     <path
//       id="path1360"
//       fill={color}
//       fillRule="evenodd"
//       strokeWidth="1"
//       d="M5.687 6.322a6.314 6.314 0 0 1 12.428-1.578 1.263 1.263 0 1 1-2.446.631 3.788 3.788 0 0 0-7.457.947v3.788h10.607c1.11 0 2.02.91 2.02 2.02v8.84a3.04 3.04 0 0 1-3.03 3.03H6.191a3.04 3.04 0 0 1-3.03-3.03v-8.84c0-1.11.908-2.02 2.02-2.02h.505zM12 12.952a2.21 2.21 0 0 0-.947 4.207v3.053a.947.947 0 1 0 1.894 0v-3.053A2.21 2.21 0 0 0 12 12.95"
//       clipRule="evenodd"
//     ></path>
//   </svg>
// );
// 
// export default SvgIcon;
